import { Navigate, Route, Routes } from 'react-router-dom';
import ChatPage from './ChatPage';
import ContactsPage from './ContactsPage';
import GroupsPage from './GroupsPage';
import SettingsPage from './SettingsPage';

export default function ChatRoutes() {
  return (
    <Routes>
      <Route index element={<ChatPage />} />
      <Route path="contacts" element={<ContactsPage />} />
      <Route path="groups" element={<GroupsPage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
